"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPStatusCodeToErrorMessageMap = void 0;
exports.HTTPStatusCodeToErrorMessageMap = {
    403: 'FORBIDDEN',
    404: 'NOT_FOUND',
    410: 'TIMEOUT',
};
